import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const HidePassword = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="m19.293 20.707-16-16 1.414-1.414 2.374 2.373A6.979 6.979 0 0 1 10.07 5l3.862.001c1.868 0 3.626.727 4.947 2.05l3.535 3.535c.78.78.78 2.05 0 2.828-1.26 1.26-2.475 2.595-3.8 3.787l2.092 2.092-1.414 1.414Zm-2.095-4.923-2.491-2.491a3.001 3.001 0 0 0-4-4L8.624 7.21c.463-.139.949-.21 1.446-.21h3.86c1.336 0 2.59.52 3.535 1.464L21.002 12c-1.256 1.256-2.458 2.625-3.804 3.785Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="m3.963 8.208-2.378 2.378a2.001 2.001 0 0 0 0 2.828L5.12 16.95A6.954 6.954 0 0 0 10.07 19h3.86c.262 0 .522-.016.78-.045L12.755 17h-2.684a4.971 4.971 0 0 1-3.536-1.464L2.999 12l2.378-2.378-1.414-1.414Z"
      fill="currentColor"
    />
  </Icon>
));

export default HidePassword;
